/*
 * @Author: your name
 * @Date: 2021-05-21 16:09:59
 * @LastEditTime: 2021-10-11 11:18:59
 * @LastEditors: Please set LastEditors
 * @Description: 除头部导航外的其他路由页面 ，但是共用头部导航的部分
 * 如 通讯录、组件中的更多页面
 * @FilePath: \NavDemo\src\router.config.js
 */

export default [{
    'path': '/MorePage',
    'name': 'MorePage',
    "component": 'morePage/MorePage',
    'meta': { 'key': 'MorePage' }
},{
  'path': '/NewsDetails',
  'name': 'NewsDetails',
  "component": 'other/NewsDetails',
  'meta': { 'key': 'NewsDetails' }
},
  ];